import React from 'react';
import { AnimatedModal } from '@/components/ui/AnimatedModal';
import AuditExplorer from './AuditExplorer';

interface AuditLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  clientId: string | null;
  clientName?: string;
  // Retained for call-site compatibility (Header passes these); the explorer is client-scoped.
  userId?: string | null;
  userName?: string;
  userEmail?: string;
}

/**
 * The single audit surface: the full enterprise AuditExplorer console hosted in a modal
 * (no standalone page). RBAC-scoped server-side — a global admin sees all clients, a
 * client-admin sees their clients. Only rendered for holders of audit.view_system.
 *
 * The console mirrors its state into the page URL (`?audit=1&…`) while open, so a view can be
 * shared or survive a reload; Header removes those params when the modal closes. `urlSync`
 * follows `isOpen` so nothing is re-written during the close animation.
 */
const AuditLogModal: React.FC<AuditLogModalProps> = ({ isOpen, onClose }) => (
  <AnimatedModal isOpen={isOpen} onClose={onClose} size="xl" className="h-[85vh]">
    <AuditExplorer scope="system" onClose={onClose} urlSync={isOpen} />
  </AnimatedModal>
);

export default AuditLogModal;
